import React, { useState, useEffect } from 'react';

interface AudioSequencingActivityProps {
  timeLeft: number;
  onInteraction: (data: any) => void;
}

export function AudioSequencingActivity({ timeLeft, onInteraction }: AudioSequencingActivityProps) {
  const [sequence, setSequence] = useState<number[]>([]);
  const [userSequence, setUserSequence] = useState<number[]>([]);
  const [playing, setPlaying] = useState(false);

  const sounds = ['🔴', '🟡', '🟢', '🔵'];

  useEffect(() => {
    // Generate initial sequence
    const newSequence = Array.from({ length: 3 }, () => Math.floor(Math.random() * 4));
    setSequence(newSequence);
    playSequence(newSequence);
  }, []);

  const playSequence = async (seq: number[]) => {
    setPlaying(true);
    for (let i = 0; i < seq.length; i++) {
      await new Promise(resolve => setTimeout(resolve, 800));
      // Visual feedback for sound
      onInteraction({ type: 'sound_play', index: seq[i], timestamp: Date.now() });
    }
    setPlaying(false);
  };

  const handleSoundClick = (index: number) => {
    if (playing) return;

    const newUserSequence = [...userSequence, index];
    setUserSequence(newUserSequence);
    onInteraction({ type: 'sound_click', index, timestamp: Date.now() });

    if (newUserSequence.length === sequence.length) {
      const isCorrect = newUserSequence.every((val, i) => val === sequence[i]);
      setTimeout(() => {
        setUserSequence([]);
        if (isCorrect) {
          const nextSequence = Array.from({ length: sequence.length + 1 }, () => Math.floor(Math.random() * 4));
          setSequence(nextSequence);
          playSequence(nextSequence);
        }
      }, 1000);
    }
  };

  return (
    <div className="text-center">
      <p className="text-lg font-semibold text-blue-700 mb-6 font-baloo">
        {playing ? "Listen to the sounds! 🎵" : "Repeat the sequence! 🎯"}
      </p>
      <div className="grid grid-cols-2 gap-4 max-w-xs mx-auto">
        {sounds.map((sound, index) => (
          <button
            key={index}
            onClick={() => handleSoundClick(index)}
            className={`w-20 h-20 rounded-xl text-3xl transition-all duration-200 ${
              userSequence.includes(index)
                ? 'bg-blue-300 scale-110'
                : 'bg-blue-100 hover:bg-blue-200'
            }`}
            disabled={playing}
          >
            {sound}
          </button>
        ))}
      </div>
    </div>
  );
}
